/* global axios */

import ApiClient from '../ApiClient';

class CustomDataProviderAPI extends ApiClient {
  constructor(id) {
    super('integrations/custom_data_provider', { accountScoped: true });
    this.id = id;
  }

  fetchData({ conversationId, contactId } = {}) {
    const params = {};
    if (conversationId) params.conversation_id = conversationId;
    if (contactId) params.contact_id = contactId;
    return axios.get(`${this.url}/${this.id}`, { params });
  }
}

export default CustomDataProviderAPI;
